import request from '@/utils/request'

export function mchtPositionList(params) {
  return request({
    url: '/mcht/position/list',
    method: 'GET',
    params: params
  })
}
export function positionList(params) {
  return request({
    url: '/mcht/position/positionList',
    method: 'GET',
    params: params
  })
}

export function mchtDetail(params) {
  return request({
    url: '/mcht/position/mchtDetail',
    method: 'GET',
    params: params
  })
}

export function mchtDelete(params) {
  return request({
    url: '/mcht/position/offShelf',
    method: 'GET',
    params: params
  })
}

export function onShelf(params) {
  return request({
    url: '/mcht/position/onShelf',
    method: 'GET',
    params: params
  })
}

export function postionDetail(params) {
  return request({
    url: '/mcht/position/positionDetail',
    method: 'GET',
    params: params
  })
}

export function positionTodayNum(params) {
  return request({
    url: '/mcht/position/positionTodayNum',
    method: 'GET',
    params: params
  })
}

export function positionNum(params) {
  return request({
    url: '/mcht/position/positionNum',
    method: 'GET',
    params: params
  })
}

export function lastExpire(params) {
  return request({
    url: '/mcht/position/lastExpire',
    method: 'GET',
    params: params
  })
}

export function changePosition(params) {
  return request({
    url: '/mcht/position/changePosition',
    method: 'GET',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/position.js